// White, semi-transparent play badge overlaid on video previews.
export const PlayBadge = ({ size = 64, className = "" }) => (
  <span
    data-testid="play-badge"
    className={`pointer-events-none absolute inset-0 flex items-center justify-center ${className}`}
  >
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true"
      className="drop-shadow-[0_2px_10px_rgba(0,0,0,0.45)] transition-transform duration-500 group-hover:scale-110">
      <circle cx="50" cy="50" r="47" fill="rgba(255,255,255,0.14)" stroke="rgba(255,255,255,0.85)" strokeWidth="3" />
      <path d="M40 33 L70 50 L40 67 Z" fill="rgba(255,255,255,0.95)" />
    </svg>
  </span>
);
